/* [PATCH pomoc-fe v1] Izbira vsebine pomoči po aplikaciji, poti in vlogi.
   Stranka ne vidi strani ali postopkov z za: 'racunovodja' (O1). Brez vsebine -> null (gumb se ne pokaže).
   [PATCH pomoc-fe v2] + Nabava, Banka, Potni nalogi, Delovni čas; vloga 'admin' (PN/DČ) kot v meniju DashboardLayout:
   stranka vidi admin vsebino samo, če je pnVloga === 'admin'; računovodja vedno. */
import { StranPomoci, Za } from './tipi';
import { PRODAJA } from './vsebina/prodaja';
import { NABAVA } from './vsebina/nabava';
import { BANKA } from './vsebina/banka';
import { POTNI_NALOGI } from './vsebina/potni_nalogi';
import { DELOVNI_CAS } from './vsebina/delovni_cas';

const PO_APLIKACIJI: Record<string, StranPomoci[]> = {
  prodaja: PRODAJA,
  nabava: NABAVA,
  banka: BANKA,
  potni_nalogi: POTNI_NALOGI,
  delovni_cas: DELOVNI_CAS,
};

export function izberiStran(aplikacija: string | null | undefined, pot: string, iskanje: string, jeStranka: boolean, jePnAdmin: boolean = false): StranPomoci | null {
  const strani = PO_APLIKACIJI[aplikacija || ''];
  if (!strani) return null;
  const sp = new URLSearchParams(iskanje || '');
  const s = strani.find((x) => x.ujema(pot, sp));
  if (!s) return null;
  const vidno = (za: Za) => za === 'vsi' || (za === 'racunovodja' && !jeStranka) || (za === 'admin' && (!jeStranka || jePnAdmin));
  if (!vidno(s.za)) return null;
  return {
    ...s,
    postopki: s.postopki.filter((p) => vidno(p.za)),
    tezave: (s.tezave || []).filter((t) => vidno(t.za)),
  };
}

/* »videno« (namig ob prvem obisku) — faza 1 v brskalniku (odločitev Janeza 15.10.: možnost c) */
const KLJUC_VIDENO = 'aicount_pomoc_videno_v1';

export function jeVideno(kljuc: string): boolean {
  try {
    const v = JSON.parse(localStorage.getItem(KLJUC_VIDENO) || '[]');
    return Array.isArray(v) && v.indexOf(kljuc) >= 0;
  } catch {
    return true; // brez shrambe namiga ne vsiljujemo
  }
}

export function oznaciVideno(kljuc: string): void {
  try {
    const v = JSON.parse(localStorage.getItem(KLJUC_VIDENO) || '[]');
    const s: string[] = Array.isArray(v) ? v : [];
    if (s.indexOf(kljuc) < 0) s.push(kljuc);
    localStorage.setItem(KLJUC_VIDENO, JSON.stringify(s));
  } catch { /* shramba ni na voljo — tiho */ }
}
